import classNames from 'classnames'
import DeleteIcon from 'mdi-react/DeleteIcon'
import PencilIcon from 'mdi-react/PencilIcon'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
  submitForm,
  switchToEditMode,
  switchToViewMode,
} from 'scenes/Dashboard/components/OrganizationDetailsModal/duck/actions'
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { makeStyles } from 'tss-react/mui'

import { Button, IconButton, Theme } from '@mui/material'

import SubmitButton from '../../../../components/SubmitButton'
import { openDeletePopup } from '../../duck/actions'

function useOrganizationDataActions(organization: Organization) {
  const dispatch = useDispatch()

  const onClickEdit = useCallback(() => dispatch(switchToEditMode()), [dispatch])
  const onClickSave = useCallback(() => dispatch(submitForm.request()), [dispatch])
  const onClickBack = useCallback(() => dispatch(switchToViewMode()), [dispatch])
  const onClickDelete = useCallback(() => dispatch(openDeletePopup(organization.id)), [organization, dispatch])
  return {
    onClickEdit,
    onClickSave,
    onClickBack,
    onClickDelete,
  }
}

export type OrganizationDataActionsProps = {
  organization: Organization
  isInEditMode?: boolean
  submitting?: boolean
}

export const OrganizationDataActions = React.memo(
  ({ organization, isInEditMode = false, submitting = false }: OrganizationDataActionsProps) => {
    const { classes } = useStyles()
    const { onClickEdit, onClickSave, onClickBack, onClickDelete } = useOrganizationDataActions(organization)
    if (isInEditMode) {
      return (
        <div className={classes.organizationActionsContainer}>
          <div className={classes.otherActions}>
            <Button variant="text" size="medium" className={classes.backButton} onClick={onClickBack}>
              Back
            </Button>
            <SubmitButton label="Save" submitting={submitting} onClick={onClickSave} />
          </div>
        </div>
      )
    } else {
      return (
        <div className={classNames(classes.organizationActionsContainer, classes.buttonContainer)}>
          <div className={classes.userActions}></div>
          <div className={classes.otherActions}>
            <IconButton className={classes.iconButton} onClick={onClickEdit}>
              <PencilIcon />
            </IconButton>
            {
              <IconButton onClick={onClickDelete}>
                <DeleteIcon />
              </IconButton>
            }
          </div>
        </div>
      )
    }
  }
)

OrganizationDataActions.displayName = 'OrganizationDataActions'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  userSelector: {
    flex: '1 1 auto',
    marginRight: spacing(4),
  },
  organizationActionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  userActions: {
    flex: '1 1 auto',
  },
  otherActions: {
    flex: '0 0 auto',
  },
  backButton: {
    marginLeft: spacing(2),
    marginRight: spacing(2),
  },
  buttonContainer: {
    display: 'flex',
  },
  iconButton: {
    marginLeft: spacing(),
  },
}))
